/* eslint-disable */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as url from "helper/UrlHelper";
import { postData } from "utils/Gateway";

const Logout = () => {
  const isLoggedIn = !!localStorage.getItem("userInfo");

  /* ------------- Language translation imports starts here ------------- */
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        if (isLoggedIn) {
          await postData(url.API_BASE_URL + url.API_LOGOUT);
          localStorage.clear();
          i18n.changeLanguage("en");
          window.location.reload();
        }
      } catch (error) {
        console.log(error.message);
        localStorage.clear();
        window.location.reload();
      }
    };
    handleLogout();
  }, []);
};

export default Logout;
